"use client";

const ROUTE_FLASH_KEY = "atech-route-flash";

export function setRouteFlash(message: string) {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.sessionStorage.setItem(ROUTE_FLASH_KEY, message);
  } catch {
    /* ignore storage failures */
  }
}

export function consumeRouteFlash(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const value = window.sessionStorage.getItem(ROUTE_FLASH_KEY);
    if (value) {
      window.sessionStorage.removeItem(ROUTE_FLASH_KEY);
    }
    return value;
  } catch {
    return null;
  }
}
